import React, { FC } from 'react';
import { useImpressionableRef } from '../../hooks/useImpressionableRef';

interface AISummaryPlacehoderProps {
  onImpression: () => void;
}

export const AISummaryPlaceholder: FC<AISummaryPlacehoderProps> = ({ onImpression }) => {
  const ref = useImpressionableRef({ onImpression }) as React.RefObject<HTMLDivElement>;

  return <div ref={ref} aria-hidden="true" />;
};
